import { useDictionary } from '../../../../../utilities/hooks/UseDictionary';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import React from 'react';

const UploadMatchedPoisDialog = ({ setUploadVisibility, onFileUpload }) => {
    const [opacity, setOpacity] = useState(0);
    const [selectedFile, setSelectedFile] = useState(null);
    const [iterationValue, setIterationValue] = useState(null);

    const dictionary = useDictionary();

    // Handle File Selection
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    // Trigger Upload with the selected file
    const handleUploadClick = () => {
        onFileUpload(selectedFile, iterationValue); // Pass file to parent for upload
    };

    // Handle Iteration Value
    const handleIterationChange = (event) => {
        setIterationValue(event.target.value);
    }

    // Close Dialog
    const onCancelClicked = () => {
        setOpacity(0);
        setTimeout(() => {
            setUploadVisibility(false);
        }, 800);
    };

    useEffect(() => {
        setTimeout(() => {
            setOpacity(1);
        }, 50);
    }, []);

    return (
        <div className="dialog-wrapper" style={{ opacity: opacity }}>
            <div className="share-dialog-container share-dialog-container-upload" data-testid="upload-dialog" style={{maxWidth:460}}>
                <div className="share-dialog-content-container">
                    <div className="share-dialog-header">
                        <div className="login-logo" style={{ marginTop: '0' }} />
                        <div
                            onClick={onCancelClicked}
                            className="dialog-close-button"
                            style={{ position: 'unset' }}
                        />
                    </div>
                    <div className="flex-filler" />
                    <h4 style={{ fontStyle: 'normal', marginTop: 40, marginBottom: 16 }}>
                        {dictionary.upload_matched_pois_label}
                    </h4>
                    <div className="form-group" style={{marginBottom:40}}>
                        <label htmlFor="iteration">Iteration:
                            <span style={{fontWeight:300}}> (take the date time from downloaded file) </span>
                            <span style={{fontWeight:300}}>poi_list_<span style={{fontWeight:300, color:'#e72020'}}>202502082012</span>.csv</span></label>
                        <input
                            type="iteration"
                            id="iteration"
                            name="iteration"
                            onChange={handleIterationChange}
                            className="form-control-1"
                            placeholder="e.g. 202502082012"
                        />
                    </div>
                    <div className="share-link-header">
                        <input
                            type="file"
                            // accept=".csv"
                            onChange={handleFileChange}
                            className="form-control-1"
                        />
                        <div
                            className="secondary-button"
                            style={{ marginLeft: 10, fontFamily: 'Roboto' }}
                            onClick={handleUploadClick}
                        >
                            {dictionary.upload}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

UploadMatchedPoisDialog.propTypes = {
    setUploadVisibility: PropTypes.func.isRequired,
    onFileUpload: PropTypes.func.isRequired, // Function to handle file upload
};

export default UploadMatchedPoisDialog;
